import styled, { keyframes } from 'styled-components';

export const StyledSlideOut = styled.div<{ width: number | null }>`
  font-family: var(--font-family);
  font-size: 16px;
  color: #000000;
  line-height: 1em;
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
  }

  .content {
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
    width: ${({ width }) => width && width > 440 ? width : 440}px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-left: solid 1px var(--light-gray);
    box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.18);
    padding: 1.5em;
    z-index: 3;

    // Hide scrollbar
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  @media (max-width: 550px) {
    .content {
      width: 100%;
    }
  }

  // TODO: these should each move downstream to the component that needs it
  .branded-color, .back-button__back-text, .link-2, .contract.selected {
    color: ${props => props.theme.merchantColor} !important;
  }
  .back-button__back-arrow, .faqdropdownarrow {
    fill: ${props => props.theme.merchantColor} !important;
  }
`;

export const StyledMain = styled.div`
  margin: 2.5em 0 0 0;

  .header {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.5em;
    text-align: left;
    margin-bottom: 1rem;
  }

  .bullet-points {
    margin-bottom: 0.75em;
  }

  .contract-selector {
    li:focus, li:focus-within, li:hover {
      border-color: #000000;
    }
  }

  .footer {
    margin-top: 2em;
  }
`;

export const FadeIn = keyframes`
  to { background: rgba(0, 0, 0, 0.5) }
  from { background: rgba(0, 0, 0, 0) }
`;

export const StyledOverlay = styled.div`
  animation-name: ${ FadeIn }
  animation-delay: 0.4;
  animation-duration: 0.4;
`;
